import React from 'react';
import UnifiedSearchInput from '@/components/Hypertracker/UnifiedSearch';

interface HyperSearchProps {
    id: string;
    isFocusedProp?: boolean;
    'data-testid'?: string;
}

const HyperSearch: React.FC<HyperSearchProps> = ({
    id,
    isFocusedProp = false,
    'data-testid': testId,
}) => {
    return (
        <UnifiedSearchInput
            id={id}
            variant={'header'}
            isFocusedProp={isFocusedProp}
            data-testid={testId}
        />
    );
};

export default HyperSearch;
